module.exports = __webpack_public_path__ + "media/bg.74837d26.mp4";